import run from '../../utilities/run';
import render from '../../utilities/render';
import _ from "underscore";
import FxoReceivingScreenLogic from './fxoReceivingScreenLogic';

// NOTE: make the target selector a place on the webpage where you want to import this
const targetSelector = "#fxo-receiving-screen";

run(targetSelector, (outerEl)=>{
 attachHtml(outerEl);
});

function attachHtml(outerEl){
  const fxoReceivingScreenLogic = new FxoReceivingScreenLogic(outerEl);
  fxoReceivingScreenLogic.init();
};



// WEBPACK FOOTER //
// ./src/pages/fxoReceivingScreen/fxoReceivingScreen.js